import { render, staticRenderFns } from "./ReportCardIndex.vue?vue&type=template&id=6746880f"
import script from "./ReportCardIndex.js?vue&type=script&lang=js&external"
export * from "./ReportCardIndex.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports